
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/sso",
      function () {
        return require("private-next-pages/sign/sso.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/sso"])
      });
    }
  